var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 23.825L15 23.975L14.835 23.825C7.71 17.36 3 13.085 3 8.75C3 5.75 5.25 3.5 8.25 3.5C10.56 3.5 12.81 5 13.605 7.04H16.395C17.19 5 19.44 3.5 21.75 3.5C24.75 3.5 27 5.75 27 8.75C27 13.085 22.29 17.36 15.15 23.825ZM21.75 0.5C19.14 0.5 16.635 1.715 15 3.62C13.365 1.715 10.86 0.5 8.25 0.5C3.63 0.5 0 4.115 0 8.75C0 14.405 5.1 19.04 12.825 26.045L15 28.025L17.175 26.045C24.9 19.04 30 14.405 30 8.75C30 4.115 26.37 0.5 21.75 0.5Z",
    fill: "#FFE12B"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 20.019,
    cy: 15.161,
    rx: 4.589,
    ry: 4.198
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 11.71,
    cy: 12.417,
    rx: 9.639,
    ry: 7.791
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 9.841,
    cy: 8.407,
    rx: 5.767,
    ry: 5.947
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 7.18,
    cy: 4.662,
    rx: 5.383,
    ry: 0.324
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 23.234,
    cy: 9.504,
    rx: 4.13,
    ry: 4.688
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 23.952,
    cy: 13.508,
    rx: 2.177,
    ry: 1.664
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 22.157,
    cy: 6.855,
    rx: 4.831,
    ry: 3.409
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 18.456,
    cy: 6.927,
    rx: 2.151,
    ry: 2.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 18.833,
    cy: 4.527,
    rx: 1.19,
    ry: 0.725
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 6.018,
    cy: 8.399,
    rx: 3.641,
    ry: 2.885
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 6.459,
    cy: 6.439,
    rx: 3.184,
    ry: 2.181
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 5.981,
    cy: 4.413,
    rx: 1.04,
    ry: 0.926
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 13.452,
    cy: 22.05,
    rx: 3.577,
    ry: 2.746
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(255, 225, 43)"
    },
    cx: 17.181,
    cy: 19.928,
    rx: 3.132,
    ry: 2.24
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.b2c08bbf3879ea10b3b42b1678f443d1.svg";
export { ForwardRef as ReactComponent };